module.exports = __webpack_public_path__ + "img/pic_rail_box.d136c2f5.png";